import { ComponentIds, Entity, ProductComponent } from '@inter-ikea-core/core';

export const getReplaceInteriorSelection = (selectedEntity: Entity) => {
  const productRef = selectedEntity.getComponent<ProductComponent>(
    ComponentIds.PRODUCT_COMPONENT_ID
  )?.productRef;
  return productRef ? [productRef] : [];
};
